import { render, staticRenderFns } from "./ResearchMouseTooltip.vue?vue&type=template&id=07718cb2&scoped=true"
import script from "./ResearchMouseTooltip.vue?vue&type=script&lang=js"
export * from "./ResearchMouseTooltip.vue?vue&type=script&lang=js"
import style0 from "./ResearchMouseTooltip.vue?vue&type=style&index=0&id=07718cb2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07718cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07718cb2')) {
      api.createRecord('07718cb2', component.options)
    } else {
      api.reload('07718cb2', component.options)
    }
    module.hot.accept("./ResearchMouseTooltip.vue?vue&type=template&id=07718cb2&scoped=true", function () {
      api.rerender('07718cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchMouseTooltip.vue"
export default component.exports